import React from 'react';
import ReactDOM from 'react-dom';
import NavBar from './NavBar';
import axios from 'axios';
import swal from 'sweetalert';
import NumberFormat from 'react-number-format';
import './index.css';
import apiurl from './apiurl';
import Download from './export_zestawienia_exel.js';
import Zestawieniahtml from './Zestawienia_html.js';
import Print from './print_zestawienie.js';
import Print2 from './print_zestawienie_2.js';
import Print3 from './print_zestawienie_3.js';
import Gen_zestawienie from './Gen_zestawienie';
import Zestawieniahtml_3 from './Zestawienia_html 3';
import ZestawieniaPrint from './wydrukiBudzet/ZestawieniaPrint';
import PrintComponents from 'react-print-components';


export default class Pokaz_zestawienie extends React.Component {
  constructor(props) {
    super();
    this.state = {
    token: props.token ,
    username: props.username ,
    id: props.id,      
    rok: props.rok,  
    nazwastrony: 'Pokaz_zestawienie',
    grupaZestawienValue : props.grupaZestawienValue,
    zestawienieValue : props.zestawienieValue,
    rodzajValues : props.rodzajValues,
    wydzialyValues : props.wydzialyValues,
    zZadaniami : props.zZadaniami,
    pominStanyZerowe : props.pominStanyZerowe,
    pominOpisy: props.pominOpisy,
    kwotyWniosku: props.kwotyWniosku,
    czyuwagicheck: props.czyuwagicheck,
    pokazdane: false,
    tableorhtml: false,
    pobieranie: true,
    data: [],
    zadania: [],
    data3: [],
    nowezestawienie: false,
    stalytekst: props.stalytekst,
  }


}

componentDidMount() {
  this.pobierz();
}

componentWillMount(){
  ReactDOM.render(<NavBar token = {this.state.token} id = {this.state.id} rok = {this.state.rok} nazwastrony = {this.state.nazwastrony} username = {this.state.username} kodoper = {this.state.kodoper} />, document.getElementById("header")); 
}
sortowanieCyfry = (id) => {
  const { data, posortowane } = this.state;
  if (posortowane === 'tak'){
  data.sort((a, b) => a[id] - b[id]).reverse()
  this.setState({ data, posortowane: ''  })
  }
  else {
  data.sort((a, b) => a[id] - b[id])    
  this.setState({ data, posortowane: 'tak' })
  }
}

  sortowanieNazwy = (id) => {
    const { data, posortowane } = this.state;
    if (posortowane === 'tak'){
      data.sort((a, b) => a[id].localeCompare(b[id], 'pl', { sensitivity: 'base' } )).reverse();
    this.setState({ data, posortowane: '' })
    }
    else {
    data.sort((a, b) => a[id].localeCompare(b[id], 'pl', { sensitivity: 'base' } )); 
    this.setState({ data, posortowane: 'tak' })
    }
    
  }

pobierz = () => {
  let uchwala = this.props.uchwala;

  if(this.props.rozdzial.length === 5) {
    let rozdzial = this.props.rozdzial;

    axios.post(apiurl+"api/Raporty",
      {rok : this.state.rok , grupaZestawienValue : this.state.grupaZestawienValue , zestawienieValue : this.state.zestawienieValue, rodzajValues : this.state.rodzajValues, wydzialyValues : this.state.wydzialyValues, idUchwaly : this.state.id, zZadaniami : this.state.zZadaniami, pominStanyZerowe : this.state.pominStanyZerowe, pominOpisy: this.state.pominOpisy, kwotyWniosku: this.state.kwotyWniosku, rozdzial: rozdzial },
      {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
      .then(res => {
        if (this.state.zestawienieValue === "1") {
          this.setState({ data : res.data,  pokazdane: true, tableorhtml: true, pobieranie: false, nowezestawienie: false });
          // ReactDOM.render(<Download data={res.data.dane} />, document.getElementById("download"))
        } 
        else if (this.state.zestawienieValue === "2" || this.state.zestawienieValue === "5") {
          this.setState({ tableorhtml: false, pobieranie: false, nowezestawienie: false });
          ReactDOM.render(<Zestawieniahtml text1={this.props.text1} data={res.data} stalytekst={this.state.stalytekst} grupaZestawienValuetext={this.props.grupaZestawienValuetext} uchwala={uchwala} czyuwagi={this.state.czyuwagicheck} zestawienieValue={this.state.zestawienieValue} />, document.getElementById("html"));
          ReactDOM.render(<Print text1={this.props.text1} data={res.data} stalytekst={this.state.stalytekst} grupaZestawienValuetext={this.props.grupaZestawienValuetext} uchwala={uchwala} czyuwagi={this.state.czyuwagicheck} zestawienieValue={this.state.zestawienieValue} />, document.getElementById("print"));
        }
        else if (this.state.zestawienieValue === "3") {
          this.setState({ data3 : res.data, nowezestawienie: true, pobieranie: false });
          ReactDOM.render(<Print2 data={res.data} stalytekst={this.state.stalytekst} rok={this.state.rok} grupaZestawienValuetext={this.props.grupaZestawienValuetext} uchwala={uchwala} />, document.getElementById("print2"));
        }
        else if (this.state.zestawienieValue === "4") { 
          this.setState({ data: res.data })
        }
        else {
          swal("Błąd danych.") 
        }
        
      })
  .catch(error => swal(error.response.data) );

  } else { 
    let rozdzial = null 

    axios.post(apiurl+"api/Raporty?",
      {rok : this.state.rok , grupaZestawienValue : this.state.grupaZestawienValue , zestawienieValue : this.state.zestawienieValue, rodzajValues : this.state.rodzajValues, wydzialyValues : this.state.wydzialyValues, idUchwaly : this.state.id, zZadaniami : this.state.zZadaniami, pominStanyZerowe : this.state.pominStanyZerowe, pominOpisy: this.state.pominOpisy, kwotyWniosku: this.state.kwotyWniosku, rozdzial: rozdzial },
      {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
      .then(res => {
        if (this.state.zestawienieValue === "1") {
          this.setState({ data : res.data,  pokazdane: true, tableorhtml: true, pobieranie: false, nowezestawienie: false });
          // ReactDOM.render(<Download data={res.data.dane} />, document.getElementById("download"));
        } 
        else if (this.state.zestawienieValue === "2" || this.state.zestawienieValue === "5") {
          this.setState({ tableorhtml: false, pobieranie: false, nowezestawienie: false });
          ReactDOM.render(<Zestawieniahtml text1={this.props.text1} data={res.data} stalytekst={this.state.stalytekst} grupaZestawienValuetext={this.props.grupaZestawienValuetext} uchwala={uchwala} czyuwagi={this.state.czyuwagicheck} zestawienieValue={this.state.zestawienieValue} />, document.getElementById("html"));
          ReactDOM.render(<Print text1={this.props.text1} data={res.data} stalytekst={this.state.stalytekst} grupaZestawienValuetext={this.props.grupaZestawienValuetext} uchwala={uchwala} czyuwagi={this.state.czyuwagicheck} zestawienieValue={this.state.zestawienieValue} />, document.getElementById("print"));
        }
        else if (this.state.zestawienieValue === "3") {
          this.setState({ data3 : res.data, nowezestawienie: true, pobieranie: false });
          ReactDOM.render(<Print2 data={res.data} stalytekst={this.state.stalytekst} rok={this.state.rok} grupaZestawienValuetext={this.props.grupaZestawienValuetext} uchwala={uchwala} />, document.getElementById("print2"));
        }
        else if (this.state.zestawienieValue === "4") { 
          this.setState({ data: res.data })
          ReactDOM.render(<Print3 data={res.data} grupaZestawienValuetext={this.props.grupaZestawienValuetext} />, document.getElementById("print3"));
        }
        else {
          swal("Błąd danych.") 
        }
        
      })
  .catch(error => swal(error.response.data) );
  
  }
  
}

wroc = () =>{
  ReactDOM.render(<Gen_zestawienie token = {this.state.token} username = {this.state.username}  kodoper={this.state.kodoper} nazwastrony={this.state.nazwastrony} id={this.state.id} rok={this.state.rok} stalytekst={this.state.stalytekst} check1w={this.props.zZadaniami} check2w={this.props.pominStanyZerowe} check3w={this.state.pominOpisy}  />, document.getElementById("root"))
}

downloadCSVFromJson = (filename, arrayOfJson) => {
  const replacer = (key, value) => value === null ? '' : value 
  const header = Object.keys(arrayOfJson[0])
  //let csv = arrayOfJson.map(row => header.map(fieldName => 
  //JSON.stringify(row[fieldName], replacer)).join(';'))
  //csv.unshift(header.join(';'))
  //csv = csv.join('\r\n')
  let csv = arrayOfJson.map(row => {
    let line = header.map(fieldName => {
      if(fieldName === 'zadania' && row[fieldName] !== null) {
        const data = row[fieldName];
        if(data.length > 0) {
          const headerZ = data[0] ? Object.keys(data[0]) : [];
          let zadania = row[fieldName].map(rowZ => headerZ.map(fieldNameZ => 
          JSON.stringify(rowZ[fieldNameZ], replacer)).join(';'));
          zadania = zadania.join('\r\n');
          zadania = '\n ----ZADANIA \n' + zadania + '\n ----KONIEC ZADAŃ'
          return zadania
        } else {
          return null
        }
      } else {
        return JSON.stringify(row[fieldName], replacer)
      }
    }).join(';')
    return line
  })
  csv.unshift(header.join(';'))
  csv = csv.join('\r\n')

  var link = document.createElement('a');
  link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

};


render() {
const { pokazdane, data, tableorhtml, pobieranie, data3, nowezestawienie} = this.state;
const { text1, text2, wydzialytext } = this.props;
const dzis = new Date().toLocaleString();
const terazrok = new Date().getYear() + 1900;
const poprzedni = this.state.rok - 1;
let stopka = data3.stopka;
let wyddoch = this.props.grupaZestawienValuetext.charAt(0);
let uchwala = this.props.uchwala;

if(this.props.zestawienieValue === '4') {

  return (<React.Fragment>
    <div className="conatiner-fluid">
    <div className="row">
      <div className="col">
        <button type="button"  class="btn btn-light float-left ml-5"  onClick={() => ReactDOM.render(<Gen_zestawienie token = {this.state.token} username = {this.state.username}  kodoper={this.state.kodoper} nazwastrony={this.state.nazwastrony} id = {this.state.id} rok={this.state.rok} text1w={this.props.text1} value1w={this.props.grupaZestawienValue} text2w={this.props.text2} value2w={this.props.zestawienieValue} selectedOption3w={this.props.sel3} selectedOption4w={this.props.sel4} check1w={this.props.check1w} check2w={this.props.check2w} check3w={this.props.check3w} uchwala={uchwala} />, document.getElementById("root"))} id="function1" >Wróć</button>
        <div id="print3" className="float-right"></div>
      </div>
      </div>

    <div className="mt-2">
    <Zestawieniahtml_3 data={data} grupaZestawienValuetext={this.props.grupaZestawienValuetext} />
    </div>

    </div>
  </React.Fragment>

  )

} else {

return (
<React.Fragment>
<div class="container-fluid">
<h3>Zestawienie</h3>
<p>{uchwala}</p>
<hr />
{pobieranie ? (<div><center><h4>Pobieranie danych...</h4></center></div>) : null }
{nowezestawienie ? null : (<>

{tableorhtml ? (
<> 
<div><button type="button"  class="btn btn-light float-left"  onClick={() => ReactDOM.render(<Gen_zestawienie token = {this.state.token} username = {this.state.username}  kodoper={this.state.kodoper} nazwastrony={this.state.nazwastrony} id = {this.state.id} rok={this.state.rok} text1w={this.props.text1} value1w={this.props.grupaZestawienValue} text2w={this.props.text2} value2w={this.props.zestawienieValue} selectedOption3w={this.props.sel3} selectedOption4w={this.props.sel4} check1w={this.props.check1w} check2w={this.props.check2w} check3w={this.props.check3w} uchwala={uchwala} />, document.getElementById("root"))} id="function1" >Wróć</button></div>
{/* <div id="download" className="float-right"></div> */}
<PrintComponents trigger={<button type="button" class="btn btn-light float-right ml-2"><i class="fas fa-print"></i> Drukuj</button>} >
  <ZestawieniaPrint data={data} pokazdane={pokazdane} uchwala={uchwala} text1={text1} text2={text2} wydzialy={wydzialytext} />
</PrintComponents>
<button className="btn btn-light float-right" onClick={() => (this.downloadCSVFromJson('Zestawienie.csv', data.dane))}>Export excel</button>
<br></br><br></br><br></br>
<div class="table-responsive-xl card">
<table id="Tabela" class="table table-hover table-sm">   
<thead >
<tr >
    <th class="text-center" onClick={() => this.sortowanieCyfry('dzial')}><b>Dział</b></th>
    <th scope="col" class="text-center" onClick={() => this.sortowanieCyfry('rozdzial')}><b>Rozdział</b></th>
    <th scope="col" class="text-center" onClick={() => this.sortowanieCyfry('paragraf')}><b>Paragraf</b></th>
    <th scope="col" class="text-center" onClick={() => this.sortowanieCyfry('pozycja')}><b>Pozycja</b></th>
    <th scope="col" class="text-center" onClick={() => this.sortowanieNazwy('rodzaj')}><b>Rodzaj</b></th>
    <th scope="col" class="text-center" onClick={() => this.sortowanieNazwy('wydzial')}><b>Wydział</b></th>
    <th scope="col" class="text-center" onClick={() => this.sortowanieNazwy('nazwa')}><b>Nazwa</b></th>
    <th scope="col" class="text-center " onClick={() => this.sortowanieCyfry('poczatkowy')}><b>Plan początkowy</b></th>
    <th scope="col" class="text-center " onClick={() => this.sortowanieCyfry('przed')}><b>Przed zmianą</b></th>
    <th scope="col" class="text-center " onClick={() => this.sortowanieCyfry('zmniejszenia')}><b>Zmniejszenia</b></th>    
    <th scope="col" class="text-center " onClick={() => this.sortowanieCyfry('zwiekszenia')}><b>Zwiększenia</b></th>    
    <th scope="col" class="text-center " onClick={() => this.sortowanieCyfry('po')}><b>Po zmianach</b></th>
    <th scope="col" class="text-center" onClick={() => this.sortowanieCyfry('wniosek')}><b>Wniosek</b></th>
</tr>
</thead>
<tbody>
{ pokazdane ? (
  data.dane.map(user => {
  const { rozdzial, dzial, paragraf, rodzaj, wydzial, nazwa, poczatkowy, przed,  pozycja, zmniejszenia, zwiekszenia, po, wniosek, zadania} = user;
  return (    
  <React.Fragment>
    <tr>
      <td ><p>{dzial}</p></td>
      <td ><p>{rozdzial}</p></td>
      <td ><p>{paragraf}</p></td>
      <td ><p>{pozycja}</p></td>
      <td ><p>{rodzaj}</p></td>
      <td ><p>{wydzial}</p></td>
      <td ><p>{nazwa}</p></td>
      <td ><p className="text-right"><NumberFormat value={poczatkowy} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></p></td>
      <td ><p className="text-right"><NumberFormat value={przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></p></td> 
      <td ><p className="text-right"><NumberFormat value={zmniejszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></p></td>
      <td ><p className="text-right"><NumberFormat value={zwiekszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></p></td>   
      <td ><p className="text-right"><NumberFormat value={po} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></p></td>
      <td ><p className="text-right"><NumberFormat value={wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></p></td>
    </tr>
    {zadania ? (<>
    {zadania.length > 0 ? ( <tr ><td colSpan="13">
    <center><h4>Zadania</h4></center>
    <table class="table table-sm rowZadania">
    <thead>
    <tr >
    <th scope="col" class="text-center" ><b>Nazwa</b></th>
    <th scope="col" class="text-center" ><b>Początkowy</b></th>
    <th scope="col" class="text-center" ><b>Przed</b></th>
    <th scope="col" class="text-center" ><b>Zmniejszenia</b></th>
    <th scope="col" class="text-center" ><b>Zwiększenia</b></th>
    <th scope="col" class="text-center" ><b>Po</b></th>
    </tr>
    </thead>
    <tbody>
    {zadania.map(elem => {
    const { nazwa, poczatkowy, przed, zmniejszenia, zwiekszenia, po } = elem;
    return (
    <tr>
      <td class="text-right">{nazwa}</td>
      <td class="text-right">{poczatkowy}</td>
      <td class="text-right">{przed}</td>
      <td class="text-right">{zmniejszenia}</td>
      <td class="text-right">{zwiekszenia}</td>
      <td class="text-right">{po}</td>
    </tr>
    );
    })
    }
    </tbody>
    </table>
    </td></tr> ) : null } </>) : null }
  </React.Fragment>
    );
  })
  ) : (<tr ><td colSpan="13"><center><p>Brak danych</p></center></td></tr>) }
</tbody>
{pokazdane ? (
<tfoot >
<tr>
  <td colSpan="7" rowspan="2"><div ><p><b>SUMA</b></p></div></td>
  <td><p><b>Początkowy</b></p></td>
  <td><p><b>Przed</b></p></td>
  <td><p><b>Zmniejszenia</b></p></td>
  <td><p><b>Zwiększenia</b></p></td>
  <td><p><b>Po</b></p></td>
  <td><p><b>Wniosek</b></p></td>
</tr>
<tr>
  <td><p><NumberFormat value={data.poczatkowy} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
  <td><p><NumberFormat value={data.przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
  <td><p><NumberFormat value={data.zmniejszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
  <td><p><NumberFormat value={data.zwiekszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
  <td><p><NumberFormat value={data.po} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
  <td><p><NumberFormat value={data.wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
</tr>
</tfoot>) : null }
</table>
</div>
</>): (
<div class="container-fluid">
<div className="float-left"><button type="button"  class="btn btn-light pull-left"  onClick={() => ReactDOM.render(<Gen_zestawienie token = {this.state.token} username = {this.state.username}  kodoper={this.state.kodoper} nazwastrony={this.state.nazwastrony} id = {this.state.id} rok={this.state.rok} text1w={this.props.text1} value1w={this.props.grupaZestawienValue} text2w={this.props.text2} value2w={this.props.zestawienieValue} selectedOption3w={this.props.sel3} selectedOption4w={this.props.sel4} check1w={this.props.check1w} check2w={this.props.check2w} check3w={this.props.check3w} uchwala={uchwala} />, document.getElementById("root"))} id="function1" >Wróć</button></div>
<div id="print" className="float-right"></div>
<br></br><br></br>
<br></br>
<div id="html" class="container overf"></div>
</div>
)}
</>) }

</div>

{nowezestawienie ? (<>

<div className="container">
<div><button type="button"  class="btn btn-light float-left"  onClick={() => ReactDOM.render(<Gen_zestawienie token = {this.state.token} username = {this.state.username}  kodoper={this.state.kodoper} nazwastrony={this.state.nazwastrony} id = {this.state.id} rok={this.state.rok} text1w={this.props.text1} value1w={this.props.grupaZestawienValue} text2w={this.props.text2} value2w={this.props.zestawienieValue} selectedOption3w={this.props.sel3} selectedOption4w={this.props.sel4} check1w={this.props.check1w} check2w={this.props.check2w} stalytekst={this.state.stalytekst} check3w={this.props.check3w} uchwala={uchwala} />, document.getElementById("root"))} id="function1" >Wróć</button></div>
<div id="print2" className="float-right"></div>
<br></br><br></br><br></br>
<div className="m-1">
<div className='row mb-2'>
  <div className="col text-right"><span className="text-right">{this.state.stalytekst}</span></div>
</div>
<center>
<table class="printable" cellSpacing="0" border="0">
<colgroup width="67"></colgroup>
<colgroup width="90"></colgroup>
<colgroup span="4" width="67"></colgroup>
<colgroup width="100"></colgroup>
<colgroup width="136"></colgroup>
<colgroup width="110"></colgroup>
<colgroup width="110"></colgroup>
<colgroup width="150"></colgroup>
<tbody>
    <tr>
        <td className="td-1" colSpan="2" height="47" align="center" valign="top"><i>Sygnatura</i></td>
        <td className="td-1" colSpan="9" align="center" valign="middle"><b><font size="3" color="#000080">Porównanie z rokiem ubiegłym dla uchwały {uchwala} <br /> na  dzień {dzis} </font></b></td>
        <td className="td-1" colSpan="2" align="center"></td>
    </tr>
    <tr>
        <td className="td-2" height="21" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="right"><b>Adresat:</b></td>
        <td className="td-3" colSpan="2" align="center"><b><font size="3">{data3.adresat}</font></b></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        {/* @*<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left"></td>*@ */}
        <td className="td-1" >Część budżetu: </td>
        <td className="td-4" colSpan="6" align="center">{data3.czescBudzetu}</td>
        <td align="left"></td>
        {/* @*<td align="left"></td>*@ */}
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" colSpan="2" height="18" align="center" valign="bottom"></td>
        <td align="left"></td>
        {/* @*<td style=" border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left"></td>*@ */}
        <td className="td-5">{wyddoch === "D" ? (<p>Dochody na zadania:</p>) : (<p>Wydatki na zadania:</p>)}</td>
        <td className="td-6" colSpan="6" align="center">{data3.rodzaje}</td>
        <td align="left"></td>
        {/* @*<td align="left"></td>*@ */}
        <td align="left"></td>
        <td className="td-3" align="center"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        {/* @*<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left"></td>*@ */}
        <td className="td-1">Wydziały: </td>
        <td className="td-4" colSpan="6" align="center">{data3.wydzialy}</td>
        <td align="left"></td>
        {/* @*<td align="left"></td>*@ */}
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" colSpan="4" height="18" align="left" valign="bottom"><i>pieczątka wydziału</i></td>
        <td align="left"><i></i></td>
        <td align="center"><i></i></td>
        <td align="left"><i></i></td>
        <td align="left"><i></i></td>
        <td align="left"><i></i></td>
        <td class="tabela" width="15%" align="center"><b><i>Plan na początek {poprzedni}</i></b></td>
        <td class="tabela" width="15%" align="center"><b><i>Przewidywane wykonanie za wrzesień {poprzedni} </i></b></td>
        <td class="tabela" width="15%" align="center"><b><i>Plan aktualny</i></b></td>
        <td class="tabela" width="5%" align="center"><b><i>Plan aktualny do przewidywanego (%)</i></b></td>
    </tr>
    <tr>
        <td class="tabela" colSpan="9" height="21" align="center"><b><font size="3">{data3.czescBudzetu} </font></b></td>
        <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data3.sumCol0} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td>
        <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data3.sumCol1} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td>
        <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data3.sumCol2} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td>
        <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data3.procent} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td>
    </tr>
    {data3.dane ? (data3.dane.map(dane1 => {
    const { nazwaGrupy, sumCol0, sumCol1, sumCol2, procent, dane} = dane1;
    return (<>
    <tr key="a">
        <td class="tabela" colSpan="9"><b><font size="3">{nazwaGrupy} </font></b></td>
        <td class="tabela" align="right"><b><NumberFormat value={sumCol0} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
        <td class="tabela" align="right"><b><NumberFormat value={sumCol1} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
        <td class="tabela" align="right"><b><NumberFormat value={sumCol2} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
        <td class="tabela" align="right"><b><NumberFormat value={procent} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
    </tr>
    {dane.map(dane3 => {
        const { dzial, rozdzial, paragraf, p4, pozycja, nazwa, poczatekRokPoprzedni, wykonanieRokPoprzedni, planRokBiezacy, procentWykonaniaDoPlanu} = dane3;
        return (<>
        <tr>
            <td class="tabela" height="8" align="center"> {dzial}</td>
            <td class="tabela" height="9" align="center">{rozdzial}</td>
            <td class="tabela" height="8" align="center">{paragraf}{p4}</td>
            <td class="tabela" height="9" align="center">{pozycja}</td>
            <td class="tabela" colspan="5" align="left" valign="middle">{nazwa}</td>
            <td class="tabela" align="right" valign="middle"><NumberFormat value={poczatekRokPoprzedni} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
            <td class="tabela" align="right" valign="middle"><NumberFormat value={wykonanieRokPoprzedni} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
            <td class="tabela" align="right" valign="middle"><NumberFormat value={planRokBiezacy} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
            <td class="tabela" align="right" valign="middle"><NumberFormat value={procentWykonaniaDoPlanu} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
        </tr>
        </>); }
    )}

    </>);}
    ) ): null} 

   
         
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr>
    <td colSpan="13"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left">Opis:</td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    {data3.uwagi2 ? (<>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td colSpan="11"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td colSpan="11"><div dangerouslySetInnerHTML={ { __html: data3.uwagi2 } }></div></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td colSpan="11"></td>
        <td className="td-3" align="left"></td>
    </tr>

    </>) : null}
    
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="center"></td>
        <td align="left" colSpan="3"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;..</font></td>
        <td align="left"></td>
        <td align="center" colSpan="2"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;</font></td>
        <td align="left"></td>
        <td align="center" colSpan="3"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;</font></td>
        <td className="td-3" colSpan="2" align="center"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;..</font></td>
    </tr>
    <tr>
        <td className="td-2"></td>
        <td  colSpan="3" height="17" align="center"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaLewo } }></div></td>
        <td align="left" ><font face="Verdana" size="1"><br></br></font></td>
        <td align="left" colSpan="2"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaData } }></div></td>
        <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
        <td align="center" colSpan="3"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaSrodek } }></div></td>
        <td className="td-3" colSpan="2" align="center"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaPrawo } }></div></td>
    </tr>

    <tr>
        <td className="td-8" height="17" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-6" align="left"></td>
    </tr>
</tbody>
</table>
</center>
</div>
</div> </>) : null }

</React.Fragment>
    );
  }
  }
}

